module.exports = __webpack_public_path__ + "img/Group 121.f66baedd.svg";